module.exports = __webpack_public_path__ + "img/01.b5a5877d.png";